import React from 'react';
import './styles.css';
import Icon, { CloseOutlined } from '@ant-design/icons';
import { ReactComponent as InfoIcon } from '@BUP/assets/Icons/info.svg';
import { useLocalStorage } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';
import i18n from '../../configs/i18n';
import modoBupDesc from '../../assets/Documents/ModoBup/modobupdesc.pdf';
import faq from '../../assets/Documents/ModoBup/FAQ.pdf';

const NotificationHelper = () => {
  const [isOpen, setIsOpen] = useLocalStorage('isOpen', true);
  const [t] = useTranslation();
  const language = i18n?.language;
  return (
    <div
      className={`${
        isOpen
          ? 'notification-helper-container'
          : 'notification-helper-container minimal'
      }`}
    >
      {isOpen ? (
        <div className="notification-content">
          <Icon component={InfoIcon} className="notification-icon" />
          <CloseOutlined
            onClick={() => setIsOpen(false)}
            className="close-icon"
          />
          <p className="notification-title-text">
            {t('pages.modeBup.notificationHelper.titleHelper')}
          </p>
          <a
            href={language === 'es' ? modoBupDesc : '/'}
            target="_blank"
            rel="noreferrer"
          >
            <p className="notification-body-text">
              {t('pages.modeBup.notificationHelper.bodyHelper')}
            </p>
          </a>
          <a
            href={language === 'es' ? faq : '/'}
            target="_blank"
            rel="noreferrer"
          >
            <p className="notification-body-text">
              {t('pages.modeBup.notificationHelper.bodyHelper2')}
            </p>
          </a>
        </div>
      ) : (
        <Icon
          component={InfoIcon}
          onClick={() => setIsOpen(true)}
          className="notification-icon"
        />
      )}
    </div>
  );
};

export default NotificationHelper;
